import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    AfterViewInit
} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {Constants} from '../../../config/constants.config';

declare const require: (path: string) => { [key: string]: string; };

@Component({
    selector: 'app-dial-code-selector-modal',
    templateUrl: './dial-code-selector-modal.component.html',
    styleUrls: ['./dial-code-selector-modal.component.scss'],
})
export class DialCodeSelectorModalComponent implements AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    personalOrWizardComponent: any;
    dialCodes: { [key: string]: string; };
    searchText = '';

    constructor(
        public readonly bsModalRef: BsModalRef,
        public readonly constants: Constants,
    ) {
        this.dialCodes = require(`../../../../../../../config/country_dial_codes.json`);
        // @ts-ignore
        this.dialCodes = this.dialCodes.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0)));
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {

    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    filterDialCodes(dialCode, _this: DialCodeSelectorModalComponent) {
        if (_this.searchText.length <= 0) {
            return true;
        }

        return dialCode.name.toLowerCase().includes(_this.searchText.toLowerCase()) || dialCode.dial_code.includes(_this.searchText.toLowerCase());
    }

    selectDialCode(code) {
        this.personalOrWizardComponent.selectedPhoneDialCode = code.dial_code;
        this.personalOrWizardComponent.changeDetectorRef.markForCheck();
        this.bsModalRef.hide();
    }

    getFlagSvgPath(svg: string) {
        return `assets/images/flags/${svg}.svg`;
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }
}
